module.exports = __webpack_public_path__ + "img/lion.625a2bc8.jpg";